import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/interfaces/HomePage.vue';
import Datalytics from '@/interfaces/DatalyticsApp.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/datalytics',
    name: 'Datalytics',
    component: Datalytics
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;